import React from 'react';

import { Box, Typography } from '@mui/material';

export function EmptyAlertsState() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
        textAlign: 'center',
      }}>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Nenhum indicador encontrado
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Não há indicadores disponíveis para esta aba.
      </Typography>
    </Box>
  );
}
